import { FemaleBodyFatRangeTypes, NewFemaleBodyFatRangeTypes } from "@/constants/bodyMetrics";
import femaleLean from "@/female/assets/female-body-pic-by-id/lean.webp";
import femaleMuscular from "@/female/assets/female-body-pic-by-id/muscular.webp";
import femaleRipped from "@/female/assets/female-body-pic-by-id/ripped.webp";
import midSizedUpgrade from "@/female/assets/funnel-upgrade-female/current-body/mid-sized.webp";
import plumpUpgrade from "@/female/assets/funnel-upgrade-female/current-body/plump.webp";
import plusSizedUpgrade from "@/female/assets/funnel-upgrade-female/current-body/plus-sized.webp";
import slimUpgrade from "@/female/assets/funnel-upgrade-female/current-body/slim.webp";
import targetBodyCurvyNewUpgrade from "@/female/assets/funnel-upgrade-female/target-body/curvy.webp";
import targetBodySmallerNewUpgrade from "@/female/assets/funnel-upgrade-female/target-body/few-sizes-smaller.webp";
import targetBodySlimUpgrade from "@/female/assets/funnel-upgrade-female/target-body/slim.webp";
import targetBodyTonedUpgrade from "@/female/assets/funnel-upgrade-female/target-body/toned.webp";
import seniorsAfterCurvy from "@/female/assets/paywall-body-fat/after-pics/seniors/curvy-new.webp";
import seniorsAfterSmaller from "@/female/assets/paywall-body-fat/after-pics/seniors/few-sizes-smaller.webp";
import seniorsAfterSlim from "@/female/assets/paywall-body-fat/after-pics/seniors/slim-new.webp";
import seniorsAfterToned from "@/female/assets/paywall-body-fat/after-pics/seniors/toned-new.webp";
import seniorsBeforeMidSized from "@/female/assets/paywall-body-fat/before-pics/seniors/mid-sized.webp";
import seniorsBeforePlump from "@/female/assets/paywall-body-fat/before-pics/seniors/plump.webp";
import seniorsBeforePlusSized from "@/female/assets/paywall-body-fat/before-pics/seniors/plus-sized.webp";
import seniorsBeforeSlim from "@/female/assets/paywall-body-fat/before-pics/seniors/slim.webp";
import fiveToPaywall from "@/male/assets/paywall-body-fat/5-9.webp";
import maleBodyFat10To14 from "@/male/assets/paywall-body-fat/10-14.webp";
import fifteenToPaywall from "@/male/assets/paywall-body-fat/15-19.webp";
import maleBodyFat20To24 from "@/male/assets/paywall-body-fat/20-24.webp";
import twentyFiveToPaywall from "@/male/assets/paywall-body-fat/25-29.webp";
import maleBodyFat30To34 from "@/male/assets/paywall-body-fat/30-34.webp";
import thirtyFiveToPaywall from "@/male/assets/paywall-body-fat/35-39.webp";
import maleBodyFat35To39 from "@/male/assets/paywall-body-fat/35-39.webp";
import maleSeniorsAfterAthletic from "@/male/assets/paywall-body-fat/after-pics/seniors/athletic.webp";
import maleSeniorsAfterLean from "@/male/assets/paywall-body-fat/after-pics/seniors/lean.webp";
import maleSeniorsAfterMuscular from "@/male/assets/paywall-body-fat/after-pics/seniors/muscular.webp";
import maleSeniorsAfterRipped from "@/male/assets/paywall-body-fat/after-pics/seniors/ripped.webp";
export const enum BodyTypes {
    Athletic = "athletic",
    Muscular = "muscular",
    Slim = "slim",
    Slender = "slender",
    MidSize = "mid-sized",
    Plump = "plump",
    Extra = "extra",
    Thin = "thin",
    Lean = "lean",
    Fit = "fit",
    Toned = "toned",
    Curvy = "curvy",
    Same = "same",
    Smaller = "smaller",
    Ripped = "ripped",
    HeavyBuild = "heavy-build",
    SoftMidSection = "soft-mid-section",
}

export const enum BackendBodyTypes {
    Skinny = "skinny",
    Regular = "regular",
    Muscular = "muscular",
    Extra = "extra",
    SlightlyExtra = "slightly_extra",
    Ripped = "ripped",
    Lean = "lean",
    Bulk = "bulk",
    ExtraBulk = "extra_bulk",
    Cut = "cut",
}

export const defaultFemalePaywallBeforePicsByBodyType: Partial<Record<BodyTypes, string>> = {
    [BodyTypes.Slim]: slimUpgrade,
    [BodyTypes.MidSize]: midSizedUpgrade,
    [BodyTypes.Plump]: plumpUpgrade,
    [BodyTypes.Extra]: plusSizedUpgrade,
};

export const seniorsBeforePaywallPicByBodyType: Partial<Record<BodyTypes, string>> = {
    [BodyTypes.Slim]: seniorsBeforeSlim,
    [BodyTypes.MidSize]: seniorsBeforeMidSized,
    [BodyTypes.Extra]: seniorsBeforePlusSized,
    [BodyTypes.Plump]: seniorsBeforePlump,
};

export const femaleSeniorsBeforePicsByBodyFat: Partial<Record<NewFemaleBodyFatRangeTypes, string>> =
    {
        [NewFemaleBodyFatRangeTypes["18–22"]]: seniorsBeforePaywallPicByBodyType[BodyTypes.Slim],
        [NewFemaleBodyFatRangeTypes["23–28"]]: seniorsBeforePaywallPicByBodyType[BodyTypes.MidSize],
        [NewFemaleBodyFatRangeTypes["29–35"]]: seniorsBeforePaywallPicByBodyType[BodyTypes.Extra],
        [NewFemaleBodyFatRangeTypes["36–44"]]: seniorsBeforePaywallPicByBodyType[BodyTypes.Plump],
    };

export const funnelUpgradePaywallIter2AfterPicByBodyType: Partial<Record<BodyTypes, string>> = {
    [BodyTypes.Slim]: targetBodySlimUpgrade,
    [BodyTypes.Toned]: targetBodyTonedUpgrade,
    [BodyTypes.Curvy]: targetBodyCurvyNewUpgrade,
    [BodyTypes.Smaller]: targetBodySmallerNewUpgrade,
};

export const seniorsAfterPaywallPicByBodyType: Partial<Record<BodyTypes, string>> = {
    [BodyTypes.Slim]: seniorsAfterSlim,
    [BodyTypes.Toned]: seniorsAfterToned,
    [BodyTypes.Curvy]: seniorsAfterCurvy,
    [BodyTypes.Smaller]: seniorsAfterSmaller,
};

export const maleSeniorsBeforePaywallPicByBodyType: Partial<Record<BodyTypes, string>> = {
    [BodyTypes.Slim]: maleBodyFat10To14,
    [BodyTypes.MidSize]: maleBodyFat20To24,
    [BodyTypes.Extra]: maleBodyFat30To34,
    [BodyTypes.Plump]: maleBodyFat35To39,
};

export const maleSeniorsAfterPaywallPicByBodyType: Partial<Record<BackendBodyTypes, string>> = {
    [BackendBodyTypes.Lean]: maleSeniorsAfterLean,
    [BackendBodyTypes.Muscular]: maleSeniorsAfterMuscular,
    [BackendBodyTypes.Regular]: maleSeniorsAfterAthletic,
    [BackendBodyTypes.Ripped]: maleSeniorsAfterRipped,
};

export const funnelUpgradeMapBodyTypesToBackend: Partial<Record<BodyTypes, BackendBodyTypes>> = {
    [BodyTypes.Slim]: BackendBodyTypes.Skinny,
    [BodyTypes.MidSize]: BackendBodyTypes.Regular,
    [BodyTypes.Plump]: BackendBodyTypes.SlightlyExtra,
    [BodyTypes.Extra]: BackendBodyTypes.Extra,
};

export const maleFunnelUpgradeMapBodyTypesToBackend: Partial<Record<BodyTypes, BackendBodyTypes>> =
    {
        [BodyTypes.Slender]: BackendBodyTypes.Skinny,
        [BodyTypes.Athletic]: BackendBodyTypes.Regular,
        [BodyTypes.SoftMidSection]: BackendBodyTypes.SlightlyExtra,
        [BodyTypes.HeavyBuild]: BackendBodyTypes.Extra,
    };

export const funnelUpgradeMapTargetBodyTypesToBackend: Partial<
    Record<BodyTypes, BackendBodyTypes>
> = {
    [BodyTypes.Slim]: BackendBodyTypes.Lean,
    [BodyTypes.Toned]: BackendBodyTypes.Ripped,
    [BodyTypes.Curvy]: BackendBodyTypes.Regular,
    [BodyTypes.Smaller]: BackendBodyTypes.SlightlyExtra,
};

export const mapBodyFatToBodyType: Record<FemaleBodyFatRangeTypes, BackendBodyTypes> = {
    [FemaleBodyFatRangeTypes["10-14"]]: BackendBodyTypes.Skinny,
    [FemaleBodyFatRangeTypes["15-19"]]: BackendBodyTypes.Skinny,
    [FemaleBodyFatRangeTypes["20-24"]]: BackendBodyTypes.Regular,
    [FemaleBodyFatRangeTypes["25-29"]]: BackendBodyTypes.Regular,
    [FemaleBodyFatRangeTypes["30-34"]]: BackendBodyTypes.SlightlyExtra,
    [FemaleBodyFatRangeTypes["35-39"]]: BackendBodyTypes.SlightlyExtra,
    [FemaleBodyFatRangeTypes["40-44"]]: BackendBodyTypes.Extra,
    [FemaleBodyFatRangeTypes[">45"]]: BackendBodyTypes.Extra,
};

export const femaleBodyPicByBodyId: Partial<Record<BackendBodyTypes, string>> = {
    [BackendBodyTypes.Lean]: femaleLean,
    [BackendBodyTypes.Muscular]: femaleMuscular,
    [BackendBodyTypes.Ripped]: femaleRipped,
};

export const funnelFoxPaywallImagesByBodyTypeRange: Partial<Record<BodyTypes, string>> = {
    [BodyTypes.Slim]: fiveToPaywall,
    [BodyTypes.MidSize]: fifteenToPaywall,
    [BodyTypes.Plump]: twentyFiveToPaywall,
    [BodyTypes.Extra]: thirtyFiveToPaywall,
};
